import { render, staticRenderFns } from "./UsageStatement.vue?vue&type=template&id=b89a4862&"
import script from "./UsageStatement.vue?vue&type=script&lang=js&"
export * from "./UsageStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports